
  // src/components/profile/profileMapper.js

import PersonIcon from '@material-ui/icons/Person';
import WorkIcon from '@material-ui/icons/Work';
import BusinessIcon from '@material-ui/icons/Business';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import GroupIcon from '@material-ui/icons/Group';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import LanguageIcon from "@material-ui/icons/Language";
import defaultPhoto from 'img/default-photo.png'

const getAvatarUrl = (photo) => {
  if (!photo) {
    return defaultPhoto;
  }

  // Extract URL from HTML anchor tag
  // const match = photo.match(/href="([^"]+)"/);

  // console.log("img==>", match , photo)


  return photo || defaultPhoto;
};

const getSafeValue = (value, fallback = '-') => {
  if (
    value === null ||
    value === undefined ||
    value === '' ||
    value === 'null'
  ) {
    return fallback;
  }

  return value;
};

const generateSkills = (skillsString = '') => {
  return skillsString
    ?.split(',')
    ?.map((skill) => skill?.trim())
    ?.filter(Boolean);
};

const generateInterests = (skillsString = '') => {
  const colors = ['purple', 'blue', 'green', 'orange', 'red'];

  return skillsString
    ?.split(',')
    ?.map((skill, index) => ({
      label: skill?.trim(),
      color: colors[index % colors.length],
    }))
    ?.filter((item) => item.label);
};

export const mapProfileResponse = (apiData) => ({
  name: getSafeValue(apiData.fullname) || getSafeValue(apiData.name) || '',
  email: getSafeValue(apiData.alias) || '',
  jobTitle: getSafeValue(apiData.jobTitle) || '',
  company: getSafeValue(apiData.company) || '',
  country: getSafeValue(apiData.countryId) || '',
  division: getSafeValue(apiData.division) || '',
  avatar: getAvatarUrl(apiData.photo),
  available: getSafeValue(apiData.availabilityInTeam) ,
  // idealTeamRole: apiData.roles || '',

  bio: getSafeValue(apiData.shortInfo) || '',

  aboutFields: [
    {
      label: 'Job Title',
      value: getSafeValue(apiData.jobTitle) || '-',
      icon: WorkIcon,
    },
    // {
    //   label: 'Company',
    //   value: apiData.company || '-',
    //   icon: BusinessIcon,
    // },

    {
      label: 'Country',
      value: getSafeValue(apiData.countryId) || '-',
      icon: LocationOnIcon,
    },
    {
      label: 'Market',
      value: getSafeValue(apiData.market) || '-',
      icon: LanguageIcon,
    },
    {
      label: 'Division',
      value: getSafeValue(apiData.division) || '-',
      icon: AccountBalanceIcon,
    },
  ],

  idealTeamRole:generateInterests( getSafeValue(apiData?.roles)),
  // skills: generateSkills(apiData?.skills),

  interests: generateInterests(getSafeValue(apiData?.skills)),

  impactStats: [
    {
      label: 'Ideas Submitted',
      value: apiData.ideas || 0,
      color: 'purple',
      icon: EmojiObjectsIcon,
    },
    {
      label: 'Teams Joined',
      value: 0,
      color: 'orange',
      icon: GroupIcon,
    },
    {
      label: 'Challenges Participated',
      value: apiData.numChallenges || 0,
      color: 'blue',
      icon: FlightTakeoffIcon,
    },
    {
      label: 'Available for Team',
      value: apiData.availabilityInTeam ? 'Yes' : 'No',
      color: 'green',
      icon: CheckCircleIcon,
    },
    {
      label: 'Balance',
      value: apiData.balance || 0,
      color: 'red',
      icon: EmojiEventsIcon,
    },
  ],
});

export const sectionIcons = {
  about: PersonIcon,
  availability: CheckCircleIcon,
  bio: WorkIcon,
  skills: EmojiObjectsIcon,
  interests: EmojiEventsIcon,
};

// export const mapProfileResponse = (
//   data
// ) => {
//   console.log("profile==mpaer", data)
//   return {
//     name: data.fullname,
//     email: data.alias,
//     jobTitle: data.jobTitle,
//     company: data.company,
//     country: data.country,
//     division: data.division,
//     profileImage:  data.photo,
//     recruiterAvailable:  data.availabilityInTeam,
//   };
// };

